<template>
	<div>
		<CCard>
			<CCardHeader style="border-bottom: 0">
				Gestion des transporteurs
				<hr />
				<div class="card-header-actions">
					<CButton color="primary" v-on:click="$refs.addModal.showModal = true">
						+ Ajouter
					</CButton>
				</div>
			</CCardHeader>
			<CCardBody>
				<GDataTableRemote
					ref="mainTable"
					remote-url="/api/carriers"
					:fields="fields"
					:items-per-page="10"
					hover
					striped
					sorter
					columnFilter
					pagination>
					<template #active="{ item }">
						<td v-if="item.active" class="text-center">
							<CIcon name="cil-check" style="color: green" />
						</td>
						<td v-if="!item.active" class="text-center">
							<CIcon name="cil-ban" style="color: red" />
						</td>
					</template>

					<template #actions="{ item }">
						<td class="text-center">
							<a class="text-center icon-space" href="#" @click.prevent="showEditModal(item)">
								<CIcon name="cil-pencil" />
							</a>
						</td>
					</template>
				</GDataTableRemote>
			</CCardBody>

			<add-modal ref="addModal" v-on:refresh="refresh" />
			<edit-modal ref="editModal" v-on:refresh="refresh" />
		</CCard>
	</div>
</template>

<script>
	import GDataTableRemote from '../../../components/ghostlexly-components/GDataTableRemote';
	import AddModal from './add-modal';
	import EditModal from './edit-modal';

	export default {
		name: 'management',
		components: { EditModal, AddModal, GDataTableRemote },
		data() {
			return {
				fields: [
					{ key: 'name', label: 'Nom' },
					{
						key: 'active',
						label: 'Actif',
						type: 'select',
						filterSelectOptions: [
							{ value: 0, label: 'Non' },
							{ value: 1, label: 'Oui' },
						],
					},
					{ key: 'actions', filter: false },
				],
			};
		},

		methods: {
			refresh: function () {
				this.$refs.mainTable.refresh();
			},

			showEditModal: function (item) {
				this.$refs.editModal.item = item;
				this.$refs.editModal.showModal = true;
			},
		},
	};
</script>
